import { LoginActionType } from './login.actionCreators';
import { CHANGE_MIGROS_LOGIN_STATUS, CLEAR_REDIRECT, SAVE_REDIRECT } from './login.actionTypes';

// Action Types
// ------------------------------------

export type MigrosUser = {
	firstName: string;
	email?: string;
	gender?: string;
};

export type MigrosLoginStatusType = '' | 'anonymous' | 'authenticated' | 'loggedin' | 'loggedout';

export type LoginStateType = {
	redirectRoutePath: string | null;
	migrosLoginStatus: string | null;
};

export type RootStateType = {
	login: LoginStateType;
};

export const actionTypes = {
	LOGIN_STATUS_KNOWN: 'LOGIN/STATUS_KNOWN',

	SAVE_REDIRECT: 'LOGIN/SAVE_REDIRECT',
	CLEAR_REDIRECT: 'LOGIN/CLEAR_REDIRECT',

	CHANGE_MIGROS_LOGIN_STATUS: 'LOGIN/CHANGE_MIGROS_LOGIN_STATUS',
};

export const migrosLoginStatuses = {
	LOGGEDIN: 'mui:user:loggedin',
	AUTHENTICATED: 'authenticated',
	ANONYMOUS: 'anonymous',
	LOGGEDOUT: 'mui:user:loggedout',
	ERROR: 'mui:auth:error',
};

// Reducer
// ------------------------------------

export const initialState: LoginStateType = {
	redirectRoutePath: null,
	migrosLoginStatus: null,
};

export default (state: LoginStateType = initialState, action: LoginActionType): LoginStateType => {
	switch (action.type) {
		case CHANGE_MIGROS_LOGIN_STATUS:
			return {
				...state,
				migrosLoginStatus: action.migrosLoginStatus,
			};

		case SAVE_REDIRECT:
			return {
				...state,
				redirectRoutePath: action.routePath as any,
			};
		case CLEAR_REDIRECT:
			return {
				...state,
				redirectRoutePath: null,
			};

		default:
			return state;
	}
};
